<template>
  <AppHeader />
  <n-config-provider>
    <n-loading-bar-provider>
      <n-message-provider placement="bottom-left">
        <n-notification-provider
          placement="top-right"
          :max="5"
          :scrollable="true"
        >
          <n-dialog-provider>
            <router-view />
          </n-dialog-provider>
        </n-notification-provider>
      </n-message-provider>
    </n-loading-bar-provider>
  </n-config-provider>
  <partners />
  <BranchMap v-if="route.path !== '/contact'" />
  <testimonials />
  <faq />
  <AppFooter />
</template>
<script lang="ts" setup>
import { useRoute } from "vue-router";
import AppFooter from "@/views/partial/footer.vue";
import AppHeader from "@/views/partial/header.vue";
import faq from "@/views/partial/faq.vue";
import testimonials from "@/views/partial/testimonials.vue";
import BranchMap from "@/views/partial/map.vue";
import partners from "@/views/partial/partners.vue";
import "vue3-carousel/carousel.css";
const route = useRoute();
// Home data (siteSettings/countries/etc.) is loaded by home/index.vue itself
// via useHomeStore().getHome() - it is not needed at this App shell level.

// A repo-wide grep found exactly five naive-ui components used anywhere in
// this app, all five right here, all provider wrappers - naive-ui is
// globally registered in main.ts (app.use(naive)) for just these five.
// Named on-demand imports (`import { NConfigProvider, ... } from
// "naive-ui"`) were tried here as a bundle-size fix and *measured*, not
// assumed: it did not shrink the production bundle (chunk-vendors actually
// grew by ~38 KiB) because naive-ui's package is not tree-shaken by plain
// ESM named imports alone without an additional bundler-level plugin
// (e.g. unplugin-vue-components or a babel-plugin-import style resolver),
// which this project does not have configured. Reverted rather than kept
// as an unproven "optimization" - see
// docs/v4-migration/DERAYAH-VUE-V4-FULL-MODERNIZATION-CERT-001.md,
// Performance Findings, for the measured before/after numbers and the
// real fix this would need (adding such a plugin) if pursued later.
</script>
